export const timeRanges = [
  { key: 'semana', label: 'Esta semana' },
  { key: 'mes', label: 'Este mes' },
  { key: 'anio', label: 'Panorama anual' }
];

export const summaryCardConfig = [
  { label: 'Solicitudes en movimiento', key: 'activas' },
  { label: 'Listas para facturar', key: 'pendientes' },
  { label: 'Enviadas', key: 'enviadas' }
];

export const estadoFilterOptions = [
  { value: 'all', label: 'Todos los estados' },
  { value: 'Pendiente', label: 'Pendiente' },
  { value: 'Aprobada', label: 'Aprobada' },
  { value: 'Enviada', label: 'Enviada' },
  { value: 'Cliente Notificado', label: 'Cliente notificado' },
  { value: 'Factura generada', label: 'Factura generada' },
  { value: 'Rechazada', label: 'Rechazada' }
];

export const metodoPagoFilterOptions = [
  { value: 'all', label: 'Todos los métodos de pago' },
  { value: 'Pago en una sola exhibición (PUE)', label: 'Pago en una sola exhibición (PUE)' },
  { value: 'Pago en parcialidades (PPD)', label: 'Pago en parcialidades (PPD)' }
];

export const contactoFilterOptions = [
  { value: 'all', label: 'Todos los métodos de contacto' },
  { value: 'Correo Electrónico', label: 'Correo electrónico' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Ambos', label: 'Ambos' }
];

export const pendientePagoOptions = [
  { value: 'all', label: 'Pagado y pendiente' },
  { value: 'Pagado', label: 'Pagado únicamente' },
  { value: 'Pendiente de Pago', label: 'Pendiente de pago' }
];

export const requestsDataset = {
  semana: [
    {
      folio: 'DIRA9-25110001',
      cliente: 'ALFONSO DÍAZ',
      estado: 'Enviada',
      contacto: 'WhatsApp',
      metodoPago: 'Pago en una sola exhibición (PUE)',
      pendientePago: 'Pagado',
      total: '$12,345 MXN',
      responsable: 'Alma',
      actualizado: 'Hace 5 min'
    },
    {
      folio: 'DIRA9-25110008',
      cliente: 'CUU AC SERVICIOS 2020',
      estado: 'Aprobada',
      contacto: 'Correo Electrónico',
      metodoPago: 'Pago en una sola exhibición (PUE)',
      pendientePago: 'Pagado',
      total: '$8,990 MXN',
      responsable: 'Janeth',
      actualizado: 'Hace 12 min'
    },
    {
      folio: 'MOME1-25100056',
      cliente: 'HOME MAX',
      estado: 'Pendiente',
      contacto: 'Ambos',
      metodoPago: 'Pago en parcialidades (PPD)',
      pendientePago: 'Pendiente de Pago',
      total: '$25,000 MXN',
      responsable: 'Sergio',
      actualizado: 'Hace 27 min'
    }
  ],
  mes: [
    {
      folio: 'MOME1-25100049',
      cliente: 'INTER HOUSE',
      estado: 'Pendiente',
      contacto: 'Correo Electrónico',
      metodoPago: 'Pago en una sola exhibición (PUE)',
      pendientePago: 'Pendiente de Pago',
      total: '$6,110 MXN',
      responsable: 'Susy',
      actualizado: 'Ayer'
    },
    {
      folio: 'DIRA9-25110015',
      cliente: 'UNIMERCA',
      estado: 'Cliente Notificado',
      contacto: 'WhatsApp',
      metodoPago: 'Pago en parcialidades (PPD)',
      pendientePago: 'Pendiente de Pago',
      total: '$15,300 MXN',
      responsable: 'Alma',
      actualizado: 'Hace 3 h'
    },
    {
      folio: 'DIRA9-25110008',
      cliente: 'CUU AC SERVICIOS 2020',
      estado: 'Factura generada',
      contacto: 'Ambos',
      metodoPago: 'Pago en una sola exhibición (PUE)',
      pendientePago: 'Pagado',
      total: '$8,990 MXN',
      responsable: 'Janeth',
      actualizado: 'Hace 1 día'
    }
  ],
  anio: [
    {
      folio: 'DIRA9-25020011',
      cliente: 'MAXIMILIANA',
      estado: 'Aprobada',
      contacto: 'Correo Electrónico',
      metodoPago: 'Pago en una sola exhibición (PUE)',
      pendientePago: 'Pagado',
      total: '$48,990 MXN',
      responsable: 'Janeth',
      actualizado: 'Feb 12'
    },
    {
      folio: 'MOME1-24120033',
      cliente: 'ALFA SERVICIOS',
      estado: 'Enviada',
      contacto: 'WhatsApp',
      metodoPago: 'Pago en parcialidades (PPD)',
      pendientePago: 'Pagado',
      total: '$22,150 MXN',
      responsable: 'Sergio',
      actualizado: 'Dic 02'
    },
    {
      folio: 'DIRA9-25010091',
      cliente: 'CAS 2003',
      estado: 'Pendiente',
      contacto: 'Ambos',
      metodoPago: 'Pago en una sola exhibición (PUE)',
      pendientePago: 'Pendiente de Pago',
      total: '$32,870 MXN',
      responsable: 'Alma',
      actualizado: 'Ene 18'
    }
  ]
};

export const logsDataset = {
  semana: [
    {
      id: 'WF-10933',
      flujo: 'Factura Cliente',
      estado: 'OK',
      duracion: '32 s',
      mensaje: 'Twilio envió plantilla HX3c5... a 12 contactos'
    },
    {
      id: 'WF-10921',
      flujo: 'Factura Cliente',
      estado: 'Advertencia',
      duracion: '55 s',
      mensaje: 'Archivo XML omitido, reintento en cola'
    },
    {
      id: 'WF-10897',
      flujo: 'Notificación Contribuyente',
      estado: 'OK',
      duracion: '25 s',
      mensaje: 'Descarga de Google Drive y actualización Airtable'
    }
  ],
  mes: [
    {
      id: 'WF-10812',
      flujo: 'Factura Cliente',
      estado: 'Error',
      duracion: '7 s',
      mensaje: 'Credenciales Twilio expiraron, se renovaron'
    },
    {
      id: 'WF-10754',
      flujo: 'Notificación Contribuyente',
      estado: 'OK',
      duracion: '29 s',
      mensaje: 'Se creó carpeta en Drive y enlace al contribuyente'
    }
  ],
  anio: [
    {
      id: 'WF-10221',
      flujo: 'Factura Cliente',
      estado: 'Error',
      duracion: '11 s',
      mensaje: 'Límite de Airtable superado, se aplicó backoff'
    },
    {
      id: 'WF-09642',
      flujo: 'Notificación Contribuyente',
      estado: 'Advertencia',
      duracion: '41 s',
      mensaje: 'Adjunto PDF corrupto, se notificó al operador'
    },
    {
      id: 'WF-09411',
      flujo: 'Factura Cliente',
      estado: 'OK',
      duracion: '33 s',
      mensaje: 'Reintentos automáticos habilitados'
    }
  ]
};

export const attendanceUsersMock = [
  {
    id: 'usr-sn-011',
    clave: 'SN-011',
    nombre: 'Susy Najera',
    iniciales: 'SN',
    correo: 's.najera@acnegocios.mx',
    rol: 'Colaborador',
    activo: 'Si',
    horario: '09:00 a 16:00'
  },
  {
    id: 'usr-je-010',
    clave: 'JE-010',
    nombre: 'Janeth Enriquez',
    iniciales: 'JE',
    correo: 'janeth.enriquez@acnegocios.mx',
    rol: 'Colaborador',
    activo: 'Si',
    horario: '10:00 a 15:30'
  },
  {
    id: 'usr-ma-j003',
    clave: 'MA-J003',
    nombre: 'Madai Aragon',
    iniciales: 'MA',
    correo: 'madai.aragon@acnegocios.mx',
    rol: 'Usuario',
    activo: 'Si',
    horario: '14:00 a 19:00'
  },
  {
    id: 'usr-al-001',
    clave: 'AL-001',
    nombre: 'Alma Chavez',
    iniciales: 'AL',
    correo: 'alma.chavez@acnegocios.mx',
    rol: 'Administrador',
    activo: 'Si',
    horario: '09:00 a 16:00'
  }
];

export const attendanceRecordsMock = [
  {
    id: 'att-2026-01-30-sn',
    usuarioId: 'usr-sn-011',
    fecha: '2026-01-30',
    inicio: '2026-01-30T15:20:22.572Z',
    fin: '2026-01-30T20:30:00.000Z',
    estado: 'Cerrada',
    metodo: 'QR',
    validacion: 'Válida',
    duracionMin: 309,
    tipo: 'Asistencia'
  },
  {
    id: 'att-2026-01-30-je',
    usuarioId: 'usr-je-010',
    fecha: '2026-01-30',
    inicio: '2026-01-30T15:21:01.303Z',
    fin: '2026-01-30T22:00:00.000Z',
    estado: 'Cerrada',
    metodo: 'QR',
    validacion: 'Fuera de horario',
    duracionMin: 398,
    tipo: 'Asistencia'
  },
  {
    id: 'att-2026-01-30-ma',
    usuarioId: 'usr-ma-j003',
    fecha: '2026-01-30',
    inicio: '2026-01-30T15:22:22.277Z',
    fin: null,
    estado: 'Incompleta',
    metodo: 'Manual',
    validacion: 'Válida',
    duracionMin: null,
    tipo: 'Asistencia'
  },
  {
    id: 'att-2026-01-31-al',
    usuarioId: 'usr-al-001',
    fecha: '2026-01-31',
    inicio: '2026-01-31T15:33:51.002Z',
    fin: '2026-01-31T21:56:46.567Z',
    estado: 'Cerrada',
    metodo: 'Importado',
    validacion: 'Válida',
    duracionMin: 382,
    tipo: 'Asistencia'
  },
  {
    id: 'att-2026-02-01-sn',
    usuarioId: 'usr-sn-011',
    fecha: '2026-02-01',
    inicio: '2026-02-01T17:04:54.211Z',
    fin: null,
    estado: 'Abierta',
    metodo: 'QR',
    validacion: 'Duplicado',
    duracionMin: null,
    tipo: 'Asistencia'
  },
  {
    id: 'att-2026-02-02-al',
    usuarioId: 'usr-al-001',
    fecha: '2026-02-02',
    inicio: '2026-02-02T15:02:00.000Z',
    fin: '2026-02-02T20:20:00.000Z',
    estado: 'Cerrada',
    metodo: 'QR',
    validacion: 'Válida',
    duracionMin: 318,
    tipo: 'Asistencia'
  }
];

export const DEFAULT_ATTENDANCE_TEMPLATE_FILE = 'Formato Asistencia General.xlsx';

export const attendanceTemplateFiles = ['Formato Asistencia General.xlsx'];

export const attendanceUserTemplates = [];

export const attendanceUserFallbackTemplates = [];

export const attendanceTemplateOptions = [
  {
    id: 'general',
    label: 'Formato Asistencia General',
    fileName: 'Formato Asistencia General.xlsx'
  }
];

export const reminders = [
  { title: 'Subir factura', folio: 'DIRA9-25110008', due: 'hoy 14:00', owner: 'Janeth' },
  { title: 'Reintento n8n', folio: 'MOME1-25100056', due: 'en 45 min', owner: 'Sergio' }
];

export const controlCenterBoards = [
  {
    key: 'conciliation',
    title: 'Conciliación bancaria',
    description: 'Prepara archivos SAFRAN para revisión mensual y futuras sugerencias de match.',
    highlights: [
      { label: 'Historial objetivo', value: 'Airtable' },
      { label: 'Estado', value: 'Diseño visual' }
    ],
    actionLabel: 'Preparar archivos'
  },
  {
    key: 'panel',
    title: 'Facturación',
    description: 'Solicitudes, aprobaciones y automatizaciones conectadas a Airtable y n8n.',
    highlights: [
      { label: 'Solicitudes activas', value: '14' },
      { label: 'Alertas n8n', value: '2' }
    ],
    actionLabel: 'Ir al tablero'
  },
  {
    key: 'reportes',
    title: 'Reportes',
    description: 'Asistencias por usuario, estados y validaciones listas para exportar.',
    highlights: [
      { label: 'Fuente', value: 'Airtable' },
      { label: 'Salida', value: 'XLSX' }
    ],
    actionLabel: 'Ir al tablero'
  },
  {
    key: 'tax',
    title: 'Evidencias fiscales',
    description: 'Calendario y cargas XML/PDF con checklist y envíos SAT.',
    highlights: [
      { label: 'Expedientes', value: '18' },
      { label: 'Pendientes semana', value: '6' }
    ],
    actionLabel: 'Ir al tablero'
  },
];

export const taxUploadSummary = [
  {
    label: 'Expedientes recibidos',
    value: '18',
    detail: 'XML y PDF organizados en Drive',
    tone: 'success'
  },
  {
    label: 'Pendientes de declarar',
    value: '6',
    detail: 'Priorizalos según fecha límite',
    tone: 'warning'
  },
  {
    label: 'Rechazados por el SAT',
    value: '2',
    detail: 'Reintenta la carga con archivos corregidos',
    tone: 'danger'
  }
];

export const taxUploadMonths = [
  { key: '01', label: 'Ene', longLabel: 'Enero' },
  { key: '02', label: 'Feb', longLabel: 'Febrero' },
  { key: '03', label: 'Mar', longLabel: 'Marzo' },
  { key: '04', label: 'Abr', longLabel: 'Abril' },
  { key: '05', label: 'May', longLabel: 'Mayo' },
  { key: '06', label: 'Jun', longLabel: 'Junio' },
  { key: '07', label: 'Jul', longLabel: 'Julio' },
  { key: '08', label: 'Ago', longLabel: 'Agosto' },
  { key: '09', label: 'Sep', longLabel: 'Septiembre' },
  { key: '10', label: 'Oct', longLabel: 'Octubre' },
  { key: '11', label: 'Nov', longLabel: 'Noviembre' },
  { key: '12', label: 'Dic', longLabel: 'Diciembre' }
];

export const taxUploadYears = [2025, 2026, 2027];

export const taxUploadSchedule = {
  '2025-11': [
    {
      id: 'IVA-GEN-2511',
      client: 'Grupo Encinas',
      rfc: 'GEN9201109L2',
      obligation: 'IVA mensual',
      service: 'NOM',
      assignedTo: 'Susy',
      requirements: ['PDF timbrado 4.0', 'Fecha de nómina', 'Total dispersado'],
      folder: 'Drive/IMPUESTOS/IVA/Nov-2025',
      dueDate: '2025-11-14',
      dueLabel: '14 Nov',
      dueText: 'Faltan 2 días',
      dueStatus: 'dueSoon',
      status: 'Pendiente de PDF timbrado',
      statusKey: 'pending',
      notes: 'Cliente compartió PDF previo sin sello, espera versión final.'
    },
    {
      id: 'ISR-CPR-2511',
      client: 'Constructora Primo',
      rfc: 'CPR070101H10',
      obligation: 'ISR pagos provisionales',
      service: 'SUA',
      assignedTo: 'Alma',
      requirements: ['PDF SUA', 'Fecha de pago IMSS', 'Total cuotas'],
      folder: 'Drive/IMPUESTOS/ISR/Nov-2025',
      dueDate: '2025-11-15',
      dueLabel: '15 Nov',
      dueText: 'Faltan 3 días',
      dueStatus: 'dueSoon',
      status: 'En revisión de sellos',
      statusKey: 'review',
      notes: 'Validar diferencia contra papeles de trabajo.'
    },
    {
      id: 'DIOT-MAX-2509',
      client: 'Maximiliana',
      rfc: 'MAX8511259Z6',
      obligation: 'DIOT',
      service: 'ISN/ISH',
      assignedTo: 'Sergio',
      requirements: ['PDF ISN', 'Base gravable', 'Layout DIOT'],
      folder: 'Drive/IMPUESTOS/DIOT/Oct-2025',
      dueDate: '2025-11-20',
      dueLabel: '20 Nov',
      dueText: 'Faltan 8 días',
      dueStatus: 'ontrack',
      status: 'Programado para SAT',
      statusKey: 'scheduled',
      notes: 'n8n programó la carga nocturna, monitorear ejecución.'
    },
    {
      id: 'IVA-CAS-2511',
      client: 'CAS 2003',
      rfc: 'CAS0305308X4',
      obligation: 'IVA mensual',
      service: 'SAT',
      assignedTo: 'Janeth',
      requirements: ['PDF definitivo enviado a SAT', 'Acuse firmado'],
      folder: 'Drive/IMPUESTOS/IVA/Nov-2025',
      dueDate: '2025-11-10',
      dueLabel: '10 Nov',
      dueText: 'Completado',
      dueStatus: 'ontrack',
      status: 'Publicado en SAT',
      statusKey: 'sent',
      notes: 'Agregar acuse firmado a la carpeta de Drive.'
    },
    {
      id: 'RET-MOME1-2509',
      client: 'MOME1 Servicios',
      rfc: 'MOME1209162A3',
      obligation: 'Retenciones asimilados',
      service: 'SAT',
      assignedTo: 'Dirección',
      requirements: ['PDF corregido', 'Evidencia del rechazo'],
      folder: 'Drive/IMPUESTOS/RET/Oct-2025',
      dueDate: '2025-11-08',
      dueLabel: '08 Nov',
      dueText: 'Atrasado 2 días',
      dueStatus: 'late',
      status: 'Rechazo SAT por RFC',
      statusKey: 'rejected',
      notes: 'SAT indicó RFC receptor inválido, solicitar corrección.'
    },
    {
      id: 'ISR-JE-2511',
      client: 'JA Services',
      rfc: 'JAS0412018Y1',
      obligation: 'ISR mensual',
      service: 'NOM',
      assignedTo: 'Jose Alfredo',
      requirements: ['PDF Nómina', 'Papeles de trabajo firmados'],
      folder: 'Drive/IMPUESTOS/ISR/Nov-2025',
      dueDate: '2025-11-18',
      dueLabel: '18 Nov',
      dueText: 'Faltan 6 días',
      dueStatus: 'ontrack',
      status: 'Solicitado al cliente',
      statusKey: 'pending',
      notes: 'Cliente pidió confirmación de último ajuste.'
    }
  ],
  '2025-12': [
    {
      id: 'IVA-GEN-2512',
      client: 'Grupo Encinas',
      rfc: 'GEN9201109L2',
      obligation: 'IVA mensual',
      service: 'NOM',
      assignedTo: 'Susy',
      requirements: ['PDF timbrado 4.0', 'Sello digital válido'],
      folder: 'Drive/IMPUESTOS/IVA/Dic-2025',
      dueDate: '2025-12-15',
      dueLabel: '15 Dic',
      dueText: 'Faltan 18 días',
      dueStatus: 'ontrack',
      status: 'Checklist enviado',
      statusKey: 'review',
      notes: 'Esperando aprobación interna.'
    },
    {
      id: 'ISR-CPR-2512',
      client: 'Constructora Primo',
      rfc: 'CPR070101H10',
      obligation: 'ISR pagos provisionales',
      service: 'SUA',
      assignedTo: 'Alma',
      requirements: ['PDF SUA', 'Acuse preliminar'],
      folder: 'Drive/IMPUESTOS/ISR/Dic-2025',
      dueDate: '2025-12-10',
      dueLabel: '10 Dic',
      dueText: 'Faltan 13 días',
      dueStatus: 'ontrack',
      status: 'Pendiente de PDF timbrado',
      statusKey: 'pending',
      notes: 'Cliente envía insumos el viernes.'
    },
    {
      id: 'DIOT-MAX-2511',
      client: 'Maximiliana',
      rfc: 'MAX8511259Z6',
      obligation: 'DIOT',
      service: 'ISN/ISH',
      assignedTo: 'Sergio',
      requirements: ['PDF ISN', 'Layout DIOT'],
      folder: 'Drive/IMPUESTOS/DIOT/Nov-2025',
      dueDate: '2025-12-05',
      dueLabel: '05 Dic',
      dueText: 'Faltan 8 días',
      dueStatus: 'ontrack',
      status: 'Programado para SAT',
      statusKey: 'scheduled',
      notes: 'Revisar importes superiores a 50k.'
    },
    {
      id: 'RET-MOME1-2511',
      client: 'MOME1 Servicios',
      rfc: 'MOME1209162A3',
      obligation: 'Retenciones asimilados',
      service: 'SAT',
      assignedTo: 'Dirección',
      requirements: ['PDF corregido', 'Evidencia del rechazo'],
      folder: 'Drive/IMPUESTOS/RET/Nov-2025',
      dueDate: '2025-12-01',
      dueLabel: '01 Dic',
      dueText: 'Atrasado 1 día',
      dueStatus: 'late',
      status: 'Rechazo SAT por RFC',
      statusKey: 'rejected',
      notes: 'SAT sigue marcando RFC receptor inválido.'
    }
  ]
};

export const taxDueLegend = [
  {
    key: 'ontrack',
    label: 'En tiempo',
    description: 'Faltan más de 5 días para la fecha límite.'
  },
  {
    key: 'dueSoon',
    label: 'Próximo a vencer',
    description: 'Entre 1 y 5 días para la fecha límite.'
  },
  {
    key: 'late',
    label: 'Atrasado',
    description: 'La fecha de entrega se venció, requiere seguimiento inmediato.'
  }
];

export const taxUploadChecklist = [
  'Confirma que XML y PDF correspondan al mismo folio y periodo fiscal.',
  'Revisa que la carpeta de Drive siga el formato IMPUESTOS/MES/AÑO.',
  'Adjunta evidencia (acuse, captura o rechazo) al completar cada paso.',
  'Utiliza el botón “Abrir” para cargar archivos únicamente desde este tablero.'
];

export const activityResponsablesDirectory = {
  SN: { nombre: 'Susy Najera', correo: 's.najera@acnegocios.mx', rol: 'Colaborador' },
  JE: { nombre: 'Janeth Enriquez', correo: 'janeth.enriquez@acnegocios', rol: 'Colaborador' },
  JC: { nombre: 'Jaretzy Camarillo', correo: 'auxiliar-01@acnegocios.mx', rol: 'Colaborador' },
  MA: { nombre: 'Madai Aragon', correo: 'madai.aragon@acnegocios.mx', rol: 'Colaborador' },
  AL: { nombre: 'Alma Chavez', correo: 'alma.chavez@acnegocios.mx', rol: 'Administrador' },
  DIR: { nombre: 'Dirección', correo: 'direccion@acnegocios.mx', rol: 'Administrador' }
};

export const monthlyActivitiesCatalog = [
  {
    actividad: 'Enviar Nominas',
    numero: '1a',
    dia: '1-2',
    fecha: 'El primer dia habil de cada mes',
    responsables: ['SN', 'JE'],
    requiereReporte: false,
    automatizable: false,
    tipo: 'Nómina',
    subirArchivo: false,
    prioridad: '',
    clientes: [
      'AL SERVICIOS MULTIPLES EMPRESARIALES SA DE CV',
      'FOLVAZ SA DE CV',
      'ALMA JAQUELINE VARELA GONZALEZ'
    ],
    obligacion: 'NOMINA'
  },
  {
    actividad: 'Envio de ISN',
    numero: '17',
    dia: '5-6',
    fecha: 'El quinto o sexto dia habil de cada mes',
    responsables: ['SN', 'JE', 'JC'],
    requiereReporte: false,
    automatizable: false,
    tipo: 'Declaraciones',
    subirArchivo: true,
    prioridad: '',
    clientes: [
      'AL SERVICIOS MULTIPLES EMPRESARIALES SA DE CV',
      'FOLVAZ SA DE CV',
      'ARMANDO ALFONSO DIAZ ROJO'
    ],
    obligacion: 'ISN'
  },
  {
    actividad: 'Envio de SUA',
    numero: '19',
    dia: '6',
    fecha: 'El sexto dia habil de cada mes',
    responsables: ['SN', 'JE', 'JC'],
    requiereReporte: false,
    automatizable: false,
    tipo: 'Declaraciones',
    subirArchivo: true,
    prioridad: '',
    clientes: [
      'AL SERVICIOS MULTIPLES EMPRESARIALES SA DE CV',
      'FOLVAZ SA DE CV',
      'ALMA JAQUELINE VARELA GONZALEZ'
    ],
    obligacion: 'SUA'
  },
  {
    actividad: 'Envio lineas de capt',
    numero: '37',
    dia: '5-18',
    fecha: 'Entre el 5to y 18vo dia del mes',
    responsables: ['SN', 'JE', 'JC'],
    requiereReporte: false,
    automatizable: false,
    tipo: 'Declaraciones',
    subirArchivo: true,
    prioridad: '',
    clientes: [
      'AL SERVICIOS MULTIPLES EMPRESARIALES SA DE CV',
      'CENTRO COMERCIAL PLAZA VALLARTA',
      'MIRIAM JAQUELINE RODRIGUEZ PORTILLO',
      'ALMA JAQUELINE VARELA GONZALEZ',
      'ARMANDO ALFONSO DIAZ ROJO',
      'FOLVAZ SA DE CV',
      'ANA ROBLES MOLINA',
      'TRANSPORTES ROTAM SA DE CV',
      'EDMUNDO MONTES MATA'
    ],
    obligacion: 'SAT'
  },
  {
    actividad: 'DIOT del mes',
    numero: '44',
    dia: '26',
    fecha: 'Apartir del dia 26vo habil de cada mes',
    responsables: ['SN', 'JE', 'JC', 'MA'],
    requiereReporte: false,
    automatizable: false,
    tipo: 'Declaraciones',
    subirArchivo: true,
    prioridad: '',
    clientes: [
      'AL SERVICIOS MULTIPLES EMPRESARIALES SA DE CV',
      'CENTRO COMERCIAL PLAZA VALLARTA',
      'FOLVAZ SA DE CV',
      'TRANSPORTES ROTAM SA DE CV'
    ],
    obligacion: 'DIOT'
  },
  {
    actividad: 'Envio Conta Electronica',
    numero: '',
    dia: '28',
    fecha: 'Apartir del dia 28vo habil de cada mes',
    responsables: [],
    requiereReporte: false,
    automatizable: false,
    tipo: 'Declaraciones',
    subirArchivo: true,
    prioridad: '',
    clientes: [
      'AL SERVICIOS MULTIPLES EMPRESARIALES SA DE CV',
      'CENTRO COMERCIAL PLAZA VALLARTA',
      'FOLVAZ SA DE CV',
      'TRANSPORTES ROTAM SA DE CV'
    ],
    obligacion: 'CE'
  }
];

export const activityStatusLegend = [
  { key: 'done', label: 'Completado', description: 'Marcado en Calendario de Actividades o con acuse.' },
  { key: 'ontrack', label: 'En tiempo', description: 'Dentro de la ventana hábil, sin bloqueos.' },
  { key: 'dueSoon', label: 'Próximo a vencer', description: 'A 3 días o menos de la fecha objetivo.' },
  { key: 'late', label: 'Atrasado', description: 'Fuera de fecha, requiere acción inmediata.' },
  { key: 'pending', label: 'Pendiente', description: 'Sin avance o sin archivos adjuntos.' },
  { key: 'na', label: 'No aplica', description: 'Actividad no requerida para el cliente.' }
];

export const monthlyActivitySummary = {
  '2025-04': [
    {
      clientId: 'al-serv',
      client: 'AL SERVICIOS MULTIPLES EMPRESARIALES SA DE CV',
      shortName: 'Al serv',
      responsables: ['JE'],
      responsableEmails: ['janeth.enriquez@acnegocios'],
      obligations: {
        NOM: { status: 'na', activity: 'Enviar Nominas', dia: '1-2', dueText: 'No aplica' },
        SUA: { status: 'done', activity: 'Envio de SUA', dia: '6', dueText: '06 Abr' },
        'ISN/ISH': { status: 'ontrack', activity: 'Envio de ISN', dia: '5-6', dueText: '05-06 Abr' },
        SAT: { status: 'ontrack', activity: 'Envio lineas de capt', dia: '5-18', dueText: 'Entre 5 y 18 Abr' }
      }
    },
    {
      clientId: 'folvaz',
      client: 'FOLVAZ SA DE CV',
      shortName: 'Folvaz',
      responsables: ['JC'],
      responsableEmails: ['auxiliar-01@acnegocios.mx'],
      obligations: {
        NOM: { status: 'pending', activity: 'Enviar Nominas', dia: '1-2', dueText: '1-2 Abr' },
        SUA: { status: 'ontrack', activity: 'Envio de SUA', dia: '6', dueText: '06 Abr' },
        'ISN/ISH': { status: 'dueSoon', activity: 'Envio de ISN', dia: '5-6', dueText: 'Vence 06 Abr' },
        SAT: { status: 'ontrack', activity: 'Envio lineas de capt', dia: '5-18', dueText: '5-18 Abr' }
      }
    },
    {
      clientId: 'vanesa-medina',
      client: 'VANESA MEDINA',
      shortName: 'Vanesa Medina',
      responsables: ['SN'],
      responsableEmails: ['s.najera@acnegocios.mx'],
      obligations: {
        NOM: { status: 'ontrack', activity: 'Enviar Nominas', dia: '1-2', dueText: '1-2 Abr' },
        SUA: { status: 'na', activity: 'Envio de SUA', dia: '6', dueText: 'No aplica' },
        'ISN/ISH': { status: 'na', activity: 'Envio de ISN', dia: '5-6', dueText: 'No aplica' },
        SAT: { status: 'ontrack', activity: 'Envio lineas de capt', dia: '5-18', dueText: '5-18 Abr' }
      }
    },
    {
      clientId: 'ale-sepulveda',
      client: 'ALE SEPULVEDA',
      shortName: 'Ale Sepulveda',
      responsables: ['MA'],
      responsableEmails: ['madai.aragon@acnegocios.mx'],
      obligations: {
        NOM: { status: 'pending', activity: 'Enviar Nominas', dia: '1-2', dueText: '1-2 Abr' },
        SUA: { status: 'pending', activity: 'Envio de SUA', dia: '6', dueText: '06 Abr' },
        'ISN/ISH': { status: 'ontrack', activity: 'Envio de ISN', dia: '5-6', dueText: '5-6 Abr' },
        SAT: { status: 'dueSoon', activity: 'Envio lineas de capt', dia: '5-18', dueText: 'Vence 18 Abr' }
      }
    },
    {
      clientId: 'jose-alfredo',
      client: 'ARMANDO ALFONSO DIAZ ROJO',
      shortName: 'Jose Alfredo',
      responsables: ['JC', 'MA'],
      responsableEmails: ['auxiliar-01@acnegocios.mx', 'madai.aragon@acnegocios.mx'],
      obligations: {
        NOM: { status: 'pending', activity: 'Enviar Nominas', dia: '1-2', dueText: '1-2 Abr' },
        SUA: { status: 'pending', activity: 'Envio de SUA', dia: '6', dueText: '06 Abr' },
        'ISN/ISH': { status: 'dueSoon', activity: 'Envio de ISN', dia: '5-6', dueText: 'Vence 06 Abr' },
        SAT: { status: 'done', activity: 'Envio lineas de capt', dia: '5-18', dueText: 'Subido' }
      }
    },
    {
      clientId: 'diana-murillo',
      client: 'MIRIAM JAQUELINE RODRIGUEZ PORTILLO',
      shortName: 'Diana Murillo',
      responsables: ['JC'],
      responsableEmails: ['auxiliar-01@acnegocios.mx'],
      obligations: {
        NOM: { status: 'na', activity: 'Enviar Nominas', dia: '1-2', dueText: 'No aplica' },
        SUA: { status: 'done', activity: 'Envio de SUA', dia: '6', dueText: 'Recibido' },
        'ISN/ISH': { status: 'ontrack', activity: 'Envio de ISN', dia: '5-6', dueText: '5-6 Abr' },
        SAT: { status: 'dueSoon', activity: 'Envio lineas de capt', dia: '5-18', dueText: 'Vence 12 Abr' }
      }
    },
    {
      clientId: 'luis-muro',
      client: 'TRANSPORTES ROTAM SA DE CV',
      shortName: 'Luis Muro',
      responsables: ['SN'],
      responsableEmails: ['s.najera@acnegocios.mx'],
      obligations: {
        NOM: { status: 'ontrack', activity: 'Enviar Nominas', dia: '1-2', dueText: '1-2 Abr' },
        SUA: { status: 'ontrack', activity: 'Envio de SUA', dia: '6', dueText: '06 Abr' },
        'ISN/ISH': { status: 'late', activity: 'Envio de ISN', dia: '5-6', dueText: 'Atrasado' },
        SAT: { status: 'ontrack', activity: 'Envio lineas de capt', dia: '5-18', dueText: 'En captura' }
      }
    },
    {
      clientId: 'jaqueline-v',
      client: 'ALMA JAQUELINE VARELA GONZALEZ',
      shortName: 'Jaqueline V.',
      responsables: ['SN'],
      responsableEmails: ['s.najera@acnegocios.mx'],
      obligations: {
        NOM: { status: 'ontrack', activity: 'Enviar Nominas', dia: '1-2', dueText: '1-2 Abr' },
        SUA: { status: 'pending', activity: 'Envio de SUA', dia: '6', dueText: '06 Abr' },
        'ISN/ISH': { status: 'late', activity: 'Envio de ISN', dia: '5-6', dueText: 'Atrasado' },
        SAT: { status: 'ontrack', activity: 'Envio lineas de capt', dia: '5-18', dueText: 'En captura' }
      }
    }
  ],
  '2025-05': []
};
